<template>
    <div class="k">
        <div class="header-bg">
            <ul class="left-bg">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <div class="title-bg">
                <span>云仓装箱实时任务监控</span>
                <!-- <span class="date">{{ date }}</span> -->
            </div>
            <ul class="right-bg">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <span class="date">{{ date }}</span>
            </ul>
        </div>
       
         <!-- 主体模块 -->
    <div class="main-bg">
        <!-- 左侧模块 -->
        <div class="main-bg-left">
            <!-- 完成率 -->
            <div class="completion-bg">
                <div class="completion-bg-content">
                    <div class="rate">
                        <h5><span>{{parm.name}}</span></h5>
                        <p>{{parm.value}}</p>
                    </div>
                </div>
            </div>
            <!-- 闪电 -->
            <div class="lightning-bg">
                <div class="lightning-bg1">
                    <div class="sd1"></div>
                    <div class="jd1">
                        <ul class="cd">
                           <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                           
                        </ul>
                        <div class="box1"></div>
                        <div class="box2"></div>
                    </div>
                </div>
                <div class="lightning-bg2">
                    <div class="sd2"></div>
                    <div class="jd2">
                        <ul class="cd">
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                           
                        </ul>
                      <div class="box1"></div>
                        <div class="box2"></div>
                    </div>
                </div>
            </div>
            <!-- top3 -->
             
            <div class="top3">
                <ul>
                    <li>
                        <div class="title-bg"></div>
                        <div class="content-bg">
                            <p></p>
                            <span></span>
                        </div>
                    </li>
                    <li>
                        <div class="title-bg"></div>
                        <div class="content-bg">
                            <p></p>
                            <span></span>
                        </div>
                    </li>
                    <li>
                        <div class="title-bg"></div>
                        <div class="content-bg">
                            <p></p>
                            <span></span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 中间模块 -->
        <div class="main-bg-middle">
            <div class="external1"></div>
            <div class="external2"></div>
            <div class="external3"></div>
            <div class="external4"></div>
            <!-- 加载 -->
            <div class="jz1">
                <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="jz2">
                <ul>
                     <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <!-- 内边框 -->
            <div class="inner1"></div>
            <div class="inner2"></div>
            <!-- 内加载箭头模块 -->
            <div class="arrow-l">
                <ol>
                    <li></li>
                    <li></li>
                    <li></li>
                </ol>
            </div>
            <div class="arrow-r">
                <ol>
                    <li></li>
                    <li></li>
                    <li></li>
                </ol>
            </div>
            <!-- 中间仪表图 -->
            <div class="meter"></div>
            <!-- 中间背景canvas -->
            <div class="animate"></div>
            <!-- 销售额 -->
            <div class="sale">
				<p><span>{{parm2.value}}</span></p>
            </div>
        </div>
        <!-- 右侧模块 -->
        <div class="main-bg-right">
            <!-- 同比 -->
            <div class="compare-bg">
                <div class="compare-bg-content">
                    <div class="rate2">
                        <h5><span>{{parm.name}}</span></h5>
                        <p>{{parm.value}}</p>
                    </div>
                </div>
            </div>
            <!-- 闪电 -->
            <div class="lightning-bg">
                <div class="lightning-bg3">
                    <div class="jd3">
                        <ul class="cd">
                              <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                      <div class="box1"></div>
                      <div class="box2"></div>
                    </div>
                    <div class="sd3"></div>
                </div>
                <div class="lightning-bg4">
                    <div class="jd4">
                        <ul class="cd">
                             <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                        <div class="box1"></div>
                        <div class="box2"></div>
                    </div>
                    <div class="sd4"></div>
                </div>
            </div>
            <!-- top6 -->
            <div class="top6">
                <ul>
                    <li>
                        <div class="title-bg"></div>
                        <div class="content-bg">
                            <p></p>
                            <span></span>
                        </div>
                    </li>
                    <li>
                        <div class="title-bg"></div>
                        <div class="content-bg">
                            <p></p>
                            <span></span>
                        </div>
                    </li>
                    <li>
                        <div class="title-bg"></div>
                        <div class="content-bg">
                            <p></p>
                            <span></span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- 底部模块 -->
      <!-- 底部模块 -->
    <div class="bottom-bg">
        <div class="ul-box">
            <ul>
                <li>
                    <div class="li-content">
                        <p><span>{{parm2.name}}</span></p>
                        <p><span>{{parm2.value}}</span></p>
                        <div class="li-box">
                        </div>
                    </div>
                </li>
                <li>
                    <div class="li-content">
                        <p><span>{{parm1.name}}</span></p>
                        <p><span>{{parm1.value}}</span></p>
                        <div class="li-box">
                        </div>
                    </div>
                </li>
                <li>
                    <div class="li-content">
                        <p><span>{{parm3.name}}</span></p>
                        <p><span>{{parm3.value}}</span></p>
                        <div class="li-box">
                        </div>
                    </div>
                </li>
            </ul>
            <ul>
                <li>
                    <div class="li-content">
                        <p><span></span></p>
                        <p><span></span></p>
                        <div class="li-box">
                            <div class="box1">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/wc.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box2">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/zc.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box3">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/sq.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box4">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/tb.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="li-content">
                        <p><span>{{parm.name}}</span></p>
                        <p><span>{{parm.value}}</span></p>
                        <div class="li-box">
                            <div class="box1">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/wc.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box2">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/zc.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box3">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/sq.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box4">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/tb.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="li-content">
                        <p><span>{{parm.name}}</span></p>
                        <p><span>{{parm.value}}</span></p>
                        <div class="li-box">
                            <div class="box1">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/wc.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box2">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/zc.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box3">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/sq.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                            <div class="box4">
                                <h5><span></span></h5>
                                <div class="pic">
                                    <img src="../../../assets/display-screen-comp/img/images/tb.png" alt="">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
      
</div>
</template>

<script>
import moment from "moment";
import { BaseModule } from "@/store/modules/base/base";
import { WebsocketModule } from "@/store/modules/websocket";
import Storage from "@/util/storage";
import config from '../../../../config/service'
export default {
  data() {
    return {
      date: null,
      list: [],
      data: [],
      index: 0,
      timer: null, // 初始定时器变量名为null
      getListTimer: null, // 获取列表定时器
      parm:{
        id: 0,
        name:"",
        value: 0,
      },
      parm1:{
        id:0,
        name:"",
        value:0,
      },
      parm2:{
        id:0,
        name:"",
        value:0,
      },
      parm3:{
        id:0,
        name:"",
        value:0,
      },
      w: 0,
      sysTenantId: null,
      left_sd:{
        width: 0,
        height: 0,
        step: 0,
        canvas: null,
        ctx: null,
        pt1: null,
        pt2: null,
        ele: null,
        bg: [4, 10, 11],
      },
      left_sd_t: {
        width: 0,
        height: 0,
        step: 0,
        canvas: null,
        ctx: null,
        pt1: null,
        pt2: null,
        ele: null,
        bg: [4, 10, 11],
      },
      right_sd: {
        width: 0,
        height: 0,
        step: 0,
        canvas: null,
        ctx: null,
        pt1: null,
        pt2: null,
        ele: null,
        bg: [4, 10, 11],
      },
      right_sd_t: {
        width: 0,
        height: 0,
        step: 0,
        canvas: null,
        ctx: null,
        pt1: null,
        pt2: null,
        ele: null,
        bg: [4, 10, 11],
      },
      appAnimate: {
        canvas: null,
        filename: "spipa",
        ctx: null,
        width: 0,
        height: 0,
        dataToImageRatio: 1,
        xC: 0,
        yC: 0,
        stepCount: 0,
        particles: [],
        lifespan: 1000,
        popPerBirth: 1,
        maxPop: 200,
        birthFreq: 5,

        // Build grid
        gridSize: 8, // 运动坐标
        gridSteps: null,
        grid: [],
        gridMaxIndex: 0,
        gridSpot: null,
      },
    };
  },
  mounted() {
    this.getTenantId();
    this.start();
    this.placeholderPic();
    this.sd1(".sd1");
    this.sd2(".sd2");
    this.sd3(".sd3");
    this.sd4(".sd4");
    this.initOSWebSocket(config.mq);

    const that = this;
    this.getListTimer = setInterval(() => {
      that.getTenantId();
    }, 1000 * 60 * 5);
    this.timer = setInterval(() => {
    that.date = moment(new Date()).format("YYYY/MM/DD HH:mm:ss");
    }, 1000);
  },
  created() {
      this.$nextTick(() => {
          this.initLiOpcity();
      })
  },
  methods: {
         getTenantId() {
            BaseModule.getSysTenantId({
              auth: false,
            }).then((res) => {
                if (res.code === 200) {
                this.sysTenantId = res.data;
                BaseModule.getPackingBarcode({
                      tenantId: this.sysTenantId,
                      auth: false,
                     }).then((res) => {
                     if(res.code === 200) {
                          this.list = res.data;
                          this.parm = res.data[0]
                          this.parm1 = res.data[0]
                          this.parm2 = res.data[1]
                          this.parm3 = res.data[2]
                     }else{
                          this.$message.error(res.message);
                         }
                     }).catch((err) => {
                        console.log(err, "err");
                     });
             }else{
               this.$message.error(res.message);
             }
            }).catch((err) => {
                console.log(err, "err");
            });
            },
            start() {
  // 将定时器名字赋值到变量中
                 this.timer = setInterval(() => {
                  if (this.index < this.list.length - 1) {
                     this.index++;
                    } else {
                      this.index = 0;
                     }
                   this.parm = this.list[this.index];
                }, 2000);
            },

      initOSWebSocket(configServiceName){
            // 构造随机访问字符串【为同一服务下不同页面标识】
            const random = String(_.random(1,true)).substring(2);
            WebsocketModule.initOverallWebSocket(configServiceName,random);
            // 当前服务下所有的ws连接
            const listElement = this.$gykj_ws_list[configServiceName];
            for(let i=0; i<listElement.length; i++){
            const socket = listElement[i];
            // 直接接收消息即可
            socket.onmessage = this.websocketonmessage;
            }
            console.log("打印所有的连接服务")
            console.log(this.$gykj_ws_list);
            },

         websocketonmessage (res) { // 数据接收
            if(res.data==="bc_life_fh000004"){
                this.getTenantId();
                console.log("数据接收web消息:"+res.data)
             }
            },
    initLiOpcity() {
        const that = this;
        document.querySelectorAll(".jz1 ul li").forEach((item, index) => {
            item.style.opacity = (1 - index / 10).toFixed(1);
        });

        document.querySelectorAll(".jz2 ul li").forEach((item, index) => {
            item.style.opacity = (1 - index / 10).toFixed(1);
        });
        setTimeout(() => {
            that.jz();
        },100);
    },
    placeholderPic() {
      this.w = document.documentElement.clientWidth / 80;
      document.documentElement.style.fontSize = this.w + "px";
    },
    sd1(ele) {
      const that = this.left_sd;
      this.left_sd.ele = ele;
      this.left_sd.canvas = document.createElement("canvas");
      this.left_sd.ctx = this.left_sd.canvas.getContext("2d");
      document.querySelector(ele).appendChild(this.left_sd.canvas);
      setTimeout(() => {
        const timeID = setInterval(() => {
          that.pt1.x += 10;
          if (that.pt1.x > that.width - 10) {
            clearInterval(timeID);
          }
        }, 60);
      }, 1000);
      window.addEventListener("resize", this.setup(that));
      this.setup(that);
      setInterval(this.animate, 60);
    },
    sd2(ele) {
      const that = this.left_sd_t;
      this.left_sd_t.ele = ele;
      this.left_sd_t.canvas = document.createElement("canvas");
      this.left_sd_t.ctx = this.left_sd_t.canvas.getContext("2d");
      document.querySelector(ele).appendChild(this.left_sd_t.canvas);
      setTimeout(() => {
        const timeID = setInterval(() => {
          that.pt1.x += 10;
          if (that.pt1.x > that.width - 10) {
            clearInterval(timeID);
          }
        }, 60);
      }, 1000);

      window.addEventListener("resize", this.setup(that));
      this.setup(that);
      setInterval(this.animate2, 60);
    },
    fade(ctx, amt, width, height){
      ctx.beginPath();
      ctx.rect(0, 0, width, height);
      ctx.fillStyle = `rgba(${this.left_sd.bg[0]}, ${this.left_sd.bg[1]}, ${this.left_sd.bg[2]}, ${amt})`;
      ctx.fill();
    },
    animate() {
      this.left_sd.step++;
      this.blur(this.left_sd.ctx, this.left_sd.canvas, 1);
      this.draw(this.left_sd);
      this.fade(this.left_sd.ctx, 0.1, this.left_sd.width, this.left_sd.height);
    },
    animate2() {
      this.left_sd_t.step++;
      this.blur(this.left_sd_t.ctx, this.left_sd_t.canvas, 1);
      this.draw(this.left_sd_t);
      this.fade(this.left_sd_t.ctx, 0.1, this.left_sd_t.width, this.left_sd_t.height);
    },
    setup(left_sd){
      left_sd.canvas.width = left_sd.width = document.querySelector(
        left_sd.ele
      ).clientWidth;
      left_sd.canvas.height = left_sd.height = document.querySelector(
        left_sd.ele
      ).clientHeight;

      left_sd.ctx.beginPath();
      left_sd.ctx.rect(0, 0, left_sd.width, left_sd.height);
      left_sd.ctx.fillStyle = `rgba(${left_sd.bg[0]}, ${
        left_sd.bg[1]
      }, ${left_sd.bg[2]}, ${1})`;
      left_sd.ctx.fill();

      left_sd.pt1 = { x: -20, y: left_sd.height / 2 };    // 闪电起点
      left_sd.pt2 = { x: -20, y: left_sd.height / 2 };    // 闪电终点
      // draw()
    },
    blur(ctx, canvas, amt) {
      ctx.filter = `blur(${amt}px)`;
      ctx.drawImage(canvas, 0, 0);
      ctx.filter = "none";
    },
    getRandMidpoint(pa, pb, range) {
      const a = Math.atan2(pb.y - pa.y, pb.x - pa.x) + Math.PI / 2;
      const half = { y: (pb.y - pa.y) / 2 + pa.y, x: (pb.x - pa.x) / 2 + pa.x };
      const offset = (Math.random() * range) / 3 - range / 6; // 这里控制闪电的抖动幅度
      const ho = {
        x: Math.cos(a) * offset + half.x,
        y: Math.sin(a) * offset + half.y,
      };
      return ho;
    },
    draw(left_sd) {
      let iterations = [left_sd.pt1, left_sd.pt2];
      let newiterations;
      let i;
      let j;
      for (i = 0; i < 8; i++) {
        newiterations = [iterations[0]];
        for (j = 1; j < iterations.length; j++) {
          newiterations.push(
            this.getRandMidpoint(
              iterations[j - 1],
              iterations[j],
              200 / (i * i + 1)
            )
          );
          newiterations.push(iterations[j]);
        }
        iterations = newiterations.concat([]);
      }
      left_sd.ctx.beginPath();
      left_sd.ctx.moveTo(iterations[0].x, iterations[0].y);
      left_sd.ctx.lineWidth = 2;
      left_sd.ctx.strokeStyle = "#04e4c9";
      // ctx.strokeStyle = `hsla(${Math.sin( step / 30) * 120 + 50},${90}%,${70}%,1)`
      for (i = 1; i < iterations.length; i++) {
        left_sd.ctx.lineTo(iterations[i].x, iterations[i].y);
      }
      left_sd.ctx.stroke();
      left_sd.ctx.closePath();
    },
    jz() {
      setInterval(() => {
        document.querySelectorAll(".jz1 ul li").forEach((item, index) => {
          if(item.style.opacity === 0 || item.style.opacity === "0"){
            item.style.opacity = 1;
          }
          item.style.opacity = parseFloat(item.style.opacity) - 0.1;
        });
      },100);
      setInterval(() => {
        document.querySelectorAll(".jz2 ul li").forEach((item, index) => {
          if (item.style.opacity === 0 || item.style.opacity === "0") {
            item.style.opacity = 1;
          }
          item.style.opacity = parseFloat(item.style.opacity) - 0.1;
        });
      }, 100);
    },

    rightSetup(right_sd) {
      right_sd.canvas.width = right_sd.width = document.querySelector(
        right_sd.ele
      ).clientWidth;
      right_sd.canvas.height = right_sd.height =
        document.querySelector(right_sd.ele).clientHeight;

      right_sd.ctx.beginPath();
      right_sd.ctx.rect(0, 0, right_sd.width, right_sd.height);
      right_sd.ctx.fillStyle = `rgba(${right_sd.bg[0]}, ${
        right_sd.bg[1]
      }, ${right_sd.bg[2]}, ${1})`;
      right_sd.ctx.fill();

      right_sd.pt1 = {
        x: right_sd.width + 20,
        y: right_sd.height / 2,
      };    // 闪电起点
      right_sd.pt2 = {
        x: right_sd.width + 20,
        y: right_sd.height / 2,
      };    // 闪电终点
    },
    rightBlur(ctx, canvas, amt) {
      ctx.filter = `blur(${amt}px)`;
      ctx.drawImage(canvas, 0, 0);
      ctx.filter = "none";
    },
    rightFade(ctx, amt, width, height) {
      ctx.beginPath();
      ctx.rect(0, 0, width, height);
      ctx.fillStyle = `rgba(${this.right_sd.bg[0]}, ${this.right_sd.bg[1]}, ${this.right_sd.bg[2]}, ${amt})`;
      ctx.fill();
    },
    rightAnimate() {
      this.right_sd.step++;
      this.rightBlur(this.right_sd.ctx, this.right_sd.canvas, 1);
      this.rightDraw( this.right_sd);
      this.rightFade(
        this.right_sd.ctx,
        0.1,
        this.right_sd.width,
        this.right_sd.height
      );
    },
    rightAnimate2() {
      const that = this.right_sd_t;
      this.right_sd_t.step++;
      this.rightBlur(this.right_sd_t.ctx, this.right_sd_t.canvas, 1);
      this.rightDraw(that);
      this.rightFade(
        this.right_sd_t.ctx,
        0.1,
        this.right_sd_t.width,
        this.right_sd_t.height
      );
    },
    rightDraw(right_sd) {
      let iterations = [right_sd.pt1, right_sd.pt2];
      let newiterations;
      let i;
      let j;
      for (i = 0; i < 8; i++) {
        newiterations = [iterations[0]];
        for (j = 1; j < iterations.length; j++) {
          newiterations.push(
            this.rightGetRandMidpoint(
              iterations[j - 1],
              iterations[j],
              200 / (i * i + 1)
            )
          );
          newiterations.push(iterations[j]);
        }
        iterations = newiterations.concat([]);
      }
      right_sd.ctx.beginPath();
      right_sd.ctx.moveTo(iterations[0].x, iterations[0].y);
      right_sd.ctx.lineWidth = 2;
      right_sd.ctx.strokeStyle = "#04e4c9";
      // ctx.strokeStyle = `hsla(${Math.sin( step / 30) * 120 + 50},${90}%,${70}%,1)`
      for (i = 1; i < iterations.length; i++) {
        right_sd.ctx.lineTo(iterations[i].x, iterations[i].y);
      }
      right_sd.ctx.stroke();
      right_sd.ctx.closePath();
    },
    rightGetRandMidpoint(pa, pb, range) {
      const a = Math.atan2(pb.y - pa.y, pb.x - pa.x) + Math.PI / 2;
      const half = { y: (pb.y - pa.y) / 2 + pa.y, x: (pb.x - pa.x) / 2 + pa.x };
      const offset = (Math.random() * range) / 3 - range / 6;     // 这里控制闪电的抖动幅度
      const ho = {
        x: Math.cos(a) * offset + half.x,
        y: Math.sin(a) * offset + half.y,
      };
      return ho;
    },
    sd3(ele) {
      const that = this.right_sd;
      this.right_sd.ele = ele;
      this.right_sd.canvas = document.createElement("canvas");
      this.right_sd.ctx = this.right_sd.canvas.getContext("2d");
      this.right_sd.bg = [4, 10, 11];
      document.querySelector(ele).appendChild(this.right_sd.canvas);
      setTimeout(() => {
        const timeID = setInterval(() => {
          that.pt1.x -= 10;
          if (that.pt1.x < 10) {
            clearInterval(timeID);
          }
        }, 60);
      }, 1000);

      window.addEventListener("resize", this.rightSetup(that));

      this.rightSetup(that);

      setInterval(this.rightAnimate, 60);
    },
    sd4(ele) {
      const that = this.right_sd_t;
      this.right_sd_t.ele = ele;
      this.right_sd_t.canvas = document.createElement("canvas");
      this.right_sd_t.ctx = this.right_sd_t.canvas.getContext("2d");
      this.right_sd_t.bg = [4, 10, 11];
      document.querySelector(ele).appendChild(this.right_sd_t.canvas);
      setTimeout(() => {
        const timeID = setInterval(() => {
          that.pt1.x -= 10;
          if (that.pt1.x < 10) {
            clearInterval(timeID);
          }
        }, 60);
      }, 1000);
      window.addEventListener("resize", this.rightSetup(that));
      this.rightSetup(that);
      setInterval(this.rightAnimate2, 60);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    if (this.getListTimer) {
      clearInterval(this.getListTimer);
    }
  },
};
</script>


<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
ol,
ul,
li {
  list-style: none;
}
.k{
	background: url(../../../assets/display-screen-comp/img/images/background.png) no-repeat center;
    background-size: 100%;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

@font-face {
  font-family: '液晶数字字体';
   src: url(../../../assets/display-screen-comp/img/fonts/液晶数字字体.TTF); 
}
.header-bg {
  width: 75%;
  height: 10%;
  margin: auto;
}
.header-bg > div {
  float: left;
}
.header-bg .title-bg {
  height: 100%;
  width: 40%;
  text-align: center;
  color: #fff;
  font-size: 1.4rem;
  display: table;
  opacity: 0;
  animation: zoomIn 0.5s linear forwards 0.8s;
}
.header-bg .title-bg span {
  display: table-cell;
  vertical-align: middle;
}
.header-bg .left-bg,
.header-bg .right-bg {
  width: 30%;
  height: 100%;
  float: left;
}
.header-bg .left-bg li,
.header-bg .right-bg li {
  width: 3.5rem;
  height: 1rem;
  background-color: #02b687;
  opacity: 0;
  margin: 0 2%;
  float: left;
  border-radius: 1rem;
  margin-top: 10%;
}
.header-bg .left-bg li:nth-of-type(1) {
  animation: show1 0.2s linear forwards;
}
.header-bg .left-bg li:nth-of-type(2) {
  animation: show2 0.2s linear forwards 0.2s;
}
.header-bg .left-bg li:nth-of-type(3) {
  animation: show3 0.2s linear forwards 0.4s;
}
.header-bg .left-bg li:nth-of-type(4) {
  animation: show4 0.2s linear forwards 0.6s;
}
.header-bg .right-bg li {
  float: right;
}
.header-bg .right-bg li:nth-of-type(1) {
  animation: show1 0.2s linear forwards;
}
.header-bg .right-bg li:nth-of-type(2) {
  animation: show2 0.2s linear forwards 0.2s;
}
.header-bg .right-bg li:nth-of-type(3) {
  animation: show3 0.2s linear forwards 0.4s;
}
.header-bg .right-bg li:nth-of-type(4) {
  animation: show4 0.2s linear forwards 0.6s;
}
.main-bg {
  width: 100%;
  height: 60%;
}
.main-bg > div {
  float: left;
}
.main-bg .main-bg-left {
  width: 22.5%;
  height: 100%;
}
.main-bg .main-bg-left .completion-bg {
  width: 100%;
  height: 30%;
  position: relative;
}
.main-bg .main-bg-left .completion-bg .completion-bg-content {
  width: 7rem;
  height: 7rem;
  background: url(../../../assets/display-screen-comp/img/images/border.png) no-repeat center;
  background-size: contain;
  position: absolute;
  left: -50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: animate1 1s linear forwards 7s;
}
.main-bg .main-bg-left .completion-bg .completion-bg-content .rate {
  width: 4rem;
  height: 4rem;
  position: absolute;
  left: 17%;
  top: 51%;
  transform: translateY(-50%);
  background: url(../../../assets/display-screen-comp/img/images/cricle.png) no-repeat center;
  background-size: contain;
  animation: rotate1 5s ease infinite;
}
.main-bg .main-bg-left .completion-bg .completion-bg-content .rate h5 {
  text-align: center;
  height: 50%;
  width: 100%;
  color: #fff;
  display: table;
}
.main-bg .main-bg-left .completion-bg .completion-bg-content .rate h5 span {
  display: table-cell;
  vertical-align: bottom;
  font-size: 0.8rem;
}
.main-bg .main-bg-left .completion-bg .completion-bg-content .rate p {
  text-align: center;
  height: 50%;
  width: 100%;
  color: #fff;
  display: table;
}
.main-bg .main-bg-left .completion-bg .completion-bg-content .rate p span {
  display: table-cell;
  vertical-align: middle;
}
.main-bg .main-bg-left .lightning-bg {
  width: 100%;
  height: 40%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1,
.main-bg .main-bg-left .lightning-bg .lightning-bg2 {
  width: 100%;
  height: 50%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 > div {
  float: left;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .sd1 {
  width: 55%;
  height: 100%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 {
  width: 45%;
  height: 100%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 > div {
  float: left;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul {
  float: left;
  margin-top: 30%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li {
  float: left;
  margin-right: 0.15rem;
  background-color: #00e4c8;
  border-radius: 50%;
  opacity: 0;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(1) {
  width: 0.5rem;
  height: 0.5rem;
  animation: show4 0.1s linear forwards 2.5s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(2) {
  width: 0.54rem;
  height: 0.54rem;
  animation: show4 0.1s linear forwards 2.6s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(3) {
  width: 0.58rem;
  height: 0.58rem;
  animation: show4 0.1s linear forwards 2.7s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(4) {
  width: 0.62rem;
  height: 0.62rem;
  animation: show4 0.1s linear forwards 2.8s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(5) {
  width: 0.66rem;
  height: 0.66rem;
  animation: show4 0.1s linear forwards 2.9s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(6) {
  width: 0.7rem;
  height: 0.7rem;
  animation: show4 0.1s linear forwards 3s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 ul li:nth-of-type(7) {
  width: 0.74rem;
  height: 0.74rem;
  animation: show4 0.1s linear forwards 3.1s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 .box1 {
  width: 0.8rem;
  height: 40%;
  background-color: #00e4c8;
  margin-left: 5%;
  margin-top: 20%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.2s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg1 .jd1 .box2 {
  width: 0.8rem;
  height: 60%;
  background-color: #00e4c8;
  margin-top: 15%;
  margin-left: 5%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.3s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 > div {
  float: left;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .sd2 {
  width: 55%;
  height: 100%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 {
  width: 45%;
  height: 100%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 > div {
  float: left;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul {
  float: left;
  margin-top: 30%;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li {
  float: left;
  margin-right: 0.15rem;
  background-color: #00e4c8;
  border-radius: 50%;
  opacity: 0;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(1) {
  width: 0.5rem;
  height: 0.5rem;
  animation: show4 0.1s linear forwards 2.5s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(2) {
  width: 0.54rem;
  height: 0.54rem;
  animation: show4 0.1s linear forwards 2.6s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(3) {
  width: 0.58rem;
  height: 0.58rem;
  animation: show4 0.1s linear forwards 2.7s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(4) {
  width: 0.62rem;
  height: 0.62rem;
  animation: show4 0.1s linear forwards 2.8s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(5) {
  width: 0.66rem;
  height: 0.66rem;
  animation: show4 0.1s linear forwards 2.9s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(6) {
  width: 0.7rem;
  height: 0.7rem;
  animation: show4 0.1s linear forwards 3s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 ul li:nth-of-type(7) {
  width: 0.74rem;
  height: 0.74rem;
  animation: show4 0.1s linear forwards 3.1s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 .box1 {
  width: 0.8rem;
  height: 40%;
  background-color: #00e4c8;
  margin-left: 5%;
  margin-top: 20%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.2s;
}
.main-bg .main-bg-left .lightning-bg .lightning-bg2 .jd2 .box2 {
  width: 0.8rem;
  height: 60%;
  background-color: #00e4c8;
  margin-top: 15%;
  margin-left: 5%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.3s;
}
.main-bg .main-bg-left .top3 {
  width: 100%;
  height: 30%;
  position: relative;
}
.main-bg .main-bg-left .top3 ul {
  width: 60%;
  height: 100%;
  position: absolute;
  left: -50%;
  top: 0;
  transform: translateX(-50%);
  animation: animate1 1s linear forwards 7s;
}
.main-bg .main-bg-left .top3 ul li {
  float: left;
  width: 30%;
  height: 100%;
  margin: 0 1.5%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(1) {
  background: url(../../../assets/display-screen-comp/img/images/1.png) no-repeat center bottom;
  background-size: 70%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(1) .title-bg {
  width: 100%;
  text-align: center;
  color: #ff7a9a;
  font-size: 0.8rem;
  margin-top: -5%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(1) .content-bg {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: 10%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(1) .content-bg p {
  font-size: 0.3rem;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(1) .content-bg span {
  font-size: 0.5rem;
  display: block;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(2) {
  background: url(../../../assets/display-screen-comp/img/images/2.png) no-repeat center bottom;
  background-size: 70%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(2) .title-bg {
  width: 100%;
  text-align: center;
  color: #01c793;
  font-size: 0.8rem;
  margin-top: 20%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(2) .content-bg {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: 10%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(2) .content-bg p {
  font-size: 0.3rem;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(2) .content-bg span {
  font-size: 0.5rem;
  display: block;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(3) {
  background: url(../../../assets/display-screen-comp/img/images/3.png) no-repeat center bottom;
  background-size: 70%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(3) .title-bg {
  width: 100%;
  text-align: center;
  color: #01c2aa;
  font-size: 0.8rem;
  margin-top: 43%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(3) .content-bg {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: 10%;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(3) .content-bg p {
  font-size: 0.3rem;
}
.main-bg .main-bg-left .top3 ul li:nth-of-type(3) .content-bg span {
  font-size: 0.3rem;
  display: block;
}
.main-bg .main-bg-middle {
  width: 55%;
  height: 100%;
  position: relative;
}
.main-bg .main-bg-middle .external1 {
  width: 15%;
  height: 100%;
  background: url(../../../assets/display-screen-comp/img/images/border1.png) no-repeat left;
  background-size: contain;
  position: absolute;
  left: 40%;
  top: 0;
  opacity: 0;
  animation: come1 0.5s linear forwards 3.4s;
}
.main-bg .main-bg-middle .external2 {
  width: 15%;
  height: 100%;
  background: url(../../../assets/display-screen-comp/img/images/border2.png) no-repeat right;
  background-size: contain;
  position: absolute;
  right: 40%;
  top: 0;
  opacity: 0;
  animation: come2 0.5s linear forwards 3.4s;
}
.main-bg .main-bg-middle .external3 {
  width: 60%;
  height: 10%;
  background: url(../../../assets/display-screen-comp/img/images/border3.png) no-repeat center top;
  background-size: contain;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 15%;
  opacity: 0;
  animation: come3 0.5s linear forwards 3.4s;
}
.main-bg .main-bg-middle .external4 {
  width: 60%;
  height: 10%;
  background: url(../../../assets/display-screen-comp/img/images/border4.png) no-repeat center bottom;
  background-size: contain;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  bottom: 10%;
  animation: come4 0.5s linear forwards 3.4s;
}
.main-bg .main-bg-middle .jz1,
.main-bg .main-bg-middle .jz2 {
  opacity: 0;
  animation: show4 0.1s linear forwards 3.8s;
}
.main-bg .main-bg-middle .jz1 ul,
.main-bg .main-bg-middle .jz2 ul {
  width: 30%;
  height: 38%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
}
.main-bg .main-bg-middle .jz1 ul li,
.main-bg .main-bg-middle .jz2 ul li {
  width: 100%;
  height: 8%;
  margin: 40% 0;
  background-color: #ff7a9a;
}
.main-bg .main-bg-middle .jz1 {
  width: 4%;
  height: 100%;
  background-color: red;
  background: url(../../../assets/display-screen-comp/img/images/jz.png) no-repeat center;
  background-size: contain;
  position: absolute;
  left: 5%;
  top: 0;
}
.main-bg .main-bg-middle .jz2 {
  width: 4%;
  height: 100%;
  background-color: red;
  background: url(../../../assets/display-screen-comp/img/images/jz.png) no-repeat center;
  background-size: contain;
  position: absolute;
  right: 5%;
  top: 0;
}
.main-bg .main-bg-middle .inner1 {
  width: 10%;
  height: 100%;
  position: absolute;
  left: 10%;
  top: 0;
  opacity: 0;
  background: url(../../../assets/display-screen-comp/img/images/leftBorder.png) no-repeat center;
  background-size: 100%;
  animation: inner1 0.3s linear forwards 3.9s;
}
.main-bg .main-bg-middle .inner2 {
  width: 10%;
  height: 100%;
  position: absolute;
  right: 10%;
  top: 0;
  opacity: 0;
  background: url(../../../assets/display-screen-comp/img/images/rightBorder.png) no-repeat center;
  background-size: 100%;
  animation: inner2 0.3s linear forwards 3.9s;
}
.main-bg .main-bg-middle .arrow-l {
  position: absolute;
  width: 10%;
  height: 20%;
  left: 15%;
  top: 40%;
  opacity: 0;
  animation: arrow1 1.5s linear infinite 4s;
}
.main-bg .main-bg-middle .arrow-l ol {
  width: 100%;
  height: 100%;
}
.main-bg .main-bg-middle .arrow-l ol li {
  width: 33%;
  height: 100%;
  float: left;
  background: url(../../../assets/display-screen-comp/img/images/yuan.png) no-repeat center;
  background-size: 60%;
}
.main-bg .main-bg-middle .arrow-l ol li:nth-of-type(3) {
  background: url(../../../assets/display-screen-comp/img/images/arrow-l.png) no-repeat center;
  background-size: 80%;
}
.main-bg .main-bg-middle .arrow-r {
  position: absolute;
  width: 10%;
  height: 20%;
  right: 15%;
  top: 40%;
  opacity: 0;
  animation: arrow2 1.5s linear infinite 4s;
}
.main-bg .main-bg-middle .arrow-r ol {
  width: 100%;
  height: 100%;
}
.main-bg .main-bg-middle .arrow-r ol li {
  width: 33%;
  height: 100%;
  float: right;
  background: url(../../../assets/display-screen-comp/img/images/yuan.png) no-repeat center;
  background-size: 60%;
}
.main-bg .main-bg-middle .arrow-r ol li:nth-of-type(3) {
  background: url(../../../assets/display-screen-comp/img/images/arrow-r.png) no-repeat center;
  background-size: 80%;
}
.main-bg .main-bg-middle .meter {
  width: 50%;
  height: 60%;
  background-color: rgba(255, 255, 255, 0.2);
  background: url(../../../assets/display-screen-comp/img/images/huan.png) no-repeat center;
  background-size: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  opacity: 0;
  transform: translate(-50%, -50%);
  animation: meter 3s linear forwards 4.1s;
}
.main-bg .main-bg-middle .animate {
  width: 70%;
  height: 70%;
  z-index: -1;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  animation: animate 1s linear forwards 6s;
}
.main-bg .main-bg-middle .animate canvas {
  transform-origin: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 40%;
}
.main-bg .main-bg-middle .sale {
  width: 16rem;
  height: 16rem;
  background: url(../../../assets/display-screen-comp/img/images/cicle.png) no-repeat center;
  background-size: contain;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -8rem;
  margin-top: -8rem;
  opacity: 0;
  animation: sale 1s linear forwards 8s;
}
.main-bg .main-bg-middle .sale p {
  width: 100%;
  height: 20%;
  text-align: center;
  color: #fff;
  display: table;
  font-size: 1.7rem;
}
.main-bg .main-bg-middle .sale p span {
  display: table-cell;
  vertical-align: middle;
}
.main-bg .main-bg-middle .sale p:nth-of-type(1) {
  font-family: '液晶数字字体';
  color: #00e4c8;
 font-size: 3.5rem;
  margin-top: 40%;
}
.main-bg .main-bg-middle .sale p:nth-of-type(2) {
  font-family: '液晶数字字体';
  font-size: 1rem;
}
.main-bg .main-bg-right {
  width: 22.5%;
  height: 100%;
}
.main-bg .main-bg-right .compare-bg {
  width: 100%;
  height: 30%;
  position: relative;
}
.main-bg .main-bg-right .compare-bg .compare-bg-content {
  width: 7rem;
  height: 7rem;
  background: url(../../../assets/display-screen-comp/img/images/border02.png) no-repeat center;
  background-size: contain;
  position: absolute;
  left: 150%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: animate2 1s linear forwards 7s;
}
.main-bg .main-bg-right .compare-bg .compare-bg-content .rate2 {
  width: 4rem;
  height: 4rem;
  position: absolute;
  left: 27%;
  top: 51%;
  transform: translateY(-50%);
  background: url(../../../assets/display-screen-comp/img/images/cricle.png) no-repeat center;
  background-size: contain;
  animation: rotate1 5s ease infinite;
}
.main-bg .main-bg-right .compare-bg .compare-bg-content .rate2 h5 {
  text-align: center;
  height: 50%;
  width: 100%;
  color: #fff;
  display: table;
}
.main-bg .main-bg-right .compare-bg .compare-bg-content .rate2 h5 span {
  display: table-cell;
  vertical-align: bottom;
  font-size: 0.8rem;
}
.main-bg .main-bg-right .compare-bg .compare-bg-content .rate2 p {
  text-align: center;
  height: 50%;
  width: 100%;
  color: #fff;
  display: table;
}
.main-bg .main-bg-right .compare-bg .compare-bg-content .rate2 p span {
  display: table-cell;
  vertical-align: middle;
}
.main-bg .main-bg-right .lightning-bg {
  width: 100%;
  height: 40%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3,
.main-bg .main-bg-right .lightning-bg .lightning-bg4 {
  width: 100%;
  height: 50%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 > div {
  float: left;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 {
  width: 45%;
  height: 100%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 > div {
  float: right;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul {
  float: right;
  margin-top: 30%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li {
  float: right;
  margin-left: 0.15rem;
  background-color: #00e4c8;
  border-radius: 50%;
  opacity: 0;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(1) {
  width: 0.5rem;
  height: 0.5rem;
  animation: show4 0.1s linear forwards 2.5s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(2) {
  width: 0.54rem;
  height: 0.54rem;
  animation: show4 0.1s linear forwards 2.6s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(3) {
  width: 0.58rem;
  height: 0.58rem;
  animation: show4 0.1s linear forwards 2.7s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(4) {
  width: 0.62rem;
  height: 0.62rem;
  animation: show4 0.1s linear forwards 2.8s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(5) {
  width: 0.66rem;
  height: 0.66rem;
  animation: show4 0.1s linear forwards 2.9s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(6) {
  width: 0.7rem;
  height: 0.7rem;
  animation: show4 0.1s linear forwards 3s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 ul li:nth-of-type(7) {
  width: 0.74rem;
  height: 0.74rem;
  animation: show4 0.1s linear forwards 3.1s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 .box1 {
  width: 0.8rem;
  height: 40%;
  background-color: #00e4c8;
  margin-right: 5%;
  margin-top: 20%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.2s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .jd3 .box2 {
  width: 0.8rem;
  height: 60%;
  background-color: #00e4c8;
  margin-top: 15%;
  margin-right: 5%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.3s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg3 .sd3 {
  width: 55%;
  height: 100%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 > div {
  float: left;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 {
  width: 45%;
  height: 100%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 > div {
  float: right;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul {
  float: right;
  margin-top: 30%;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li {
  float: right;
  margin-left: 0.15rem;
  background-color: #00e4c8;
  border-radius: 50%;
  opacity: 0;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(1) {
  width: 0.5rem;
  height: 0.5rem;
  animation: show4 0.1s linear forwards 2.5s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(2) {
  width: 0.54rem;
  height: 0.54rem;
  animation: show4 0.1s linear forwards 2.6s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(3) {
  width: 0.58rem;
  height: 0.58rem;
  animation: show4 0.1s linear forwards 2.7s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(4) {
  width: 0.62rem;
  height: 0.62rem;
  animation: show4 0.1s linear forwards 2.8s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(5) {
  width: 0.66rem;
  height: 0.66rem;
  animation: show4 0.1s linear forwards 2.9s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(6) {
  width: 0.7rem;
  height: 0.7rem;
  animation: show4 0.1s linear forwards 3s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 ul li:nth-of-type(7) {
  width: 0.74rem;
  height: 0.74rem;
  animation: show4 0.1s linear forwards 3.1s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 .box1 {
  width: 0.8rem;
  height: 40%;
  background-color: #00e4c8;
  margin-right: 5%;
  margin-top: 20%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.2s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .jd4 .box2 {
  width: 0.8rem;
  height: 60%;
  background-color: #00e4c8;
  margin-top: 15%;
  margin-right: 5%;
  border-radius: 0.8rem;
  opacity: 0;
  animation: show4 0.1s linear forwards 3.3s;
}
.main-bg .main-bg-right .lightning-bg .lightning-bg4 .sd4 {
  width: 55%;
  height: 100%;
}
.main-bg .main-bg-right .top6 {
  width: 100%;
  height: 30%;
  position: relative;
}
.main-bg .main-bg-right .top6 ul {
  width: 60%;
  height: 100%;
  position: absolute;
  left: 150%;
  top: 0;
  transform: translateX(-50%);
  animation: animate2 1s linear forwards 7s;
}
.main-bg .main-bg-right .top6 ul li {
  float: left;
  width: 30%;
  height: 100%;
  margin: 0 1.5%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(1) {
  background: url(../../../assets/display-screen-comp/img/images/4.png) no-repeat center bottom;
  background-size: 70%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(1) .title-bg {
  width: 100%;
  text-align: center;
  color: #cab636;
  font-size: 0.8rem;
  margin-top: 60%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(1) .content-bg {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: 10%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(1) .content-bg p {
  font-size: 0.3rem;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(1) .content-bg span {
  font-size: 0.5rem;
  display: block;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(2) {
  background: url(../../../assets/display-screen-comp/img/images/5.png) no-repeat center bottom;
  background-size: 70%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(2) .title-bg {
  width: 100%;
  text-align: center;
  color: #028e4f;
  font-size: 0.8rem;
  margin-top: 78%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(2) .content-bg {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: 10%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(2) .content-bg p {
  font-size: 0.3rem;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(2) .content-bg span {
  font-size: 0.5rem;
  display: block;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(3) {
  background: url(../../../assets/display-screen-comp/img/images/6.png) no-repeat center bottom;
  background-size: 70%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(3) .title-bg {
  width: 100%;
  text-align: center;
  color: #01a893;
  font-size: 0.8rem;
  margin-top: 95%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(3) .content-bg {
  width: 100%;
  text-align: center;
  color: #fff;
  margin-top: 10%;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(3) .content-bg p {
  font-size: 0.3rem;
}
.main-bg .main-bg-right .top6 ul li:nth-of-type(3) .content-bg span {
  font-size: 0.3rem;
  display: block;
}
.bottom-bg {
  width: 100%;
  height: 30%;
  position: relative;
  overflow: hidden;
}
.bottom-bg .ul-box {
  width: 200%;
  height: 100%;
  position: relative;
  /* animation: move 10s linear infinite 12s; */
}
.bottom-bg .ul-box ul {
  float: left;
  width: 50%;
  height: 100%;
}
.bottom-bg .ul-box ul li {
  width: 30%;
  height: 100%;
  margin: 0 1.5%;
  background: url(../../../assets/display-screen-comp/img/images/di.png) no-repeat center bottom;
  background-size: 50%;
  float: left;
}
.bottom-bg .ul-box ul li .li-content {
  opacity: 0;
  position: relative;
  width: 100%;
  height: 60%;
  background: url(../../../assets/display-screen-comp/img/images/bg.png) no-repeat center;
  background-size: contain;
  overflow: hidden;
  animation: show5 1s linear forwards 8.5s; 
}
.bottom-bg .ul-box ul li .li-content p {
  width: 100%;
  height: 20%;
  text-align: center;
  color: #fff;
  display: table;
}
.bottom-bg .ul-box ul li .li-content p span {
	font-size: 1.2rem;
  display: table-cell;
  vertical-align: middle;
}
.bottom-bg .ul-box ul li .li-content p:nth-of-type(1) {
  margin-top: 10%;
}
.bottom-bg .ul-box ul li .li-content p:nth-of-type(2) {
  font-family: '液晶数字字体';
  font-size: 1.5rem;
}
.bottom-bg .ul-box ul li .li-content .li-box {
  position: absolute;
  width: 70%;
  height: 80%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.bottom-bg .ul-box ul li .li-content .li-box .box1,
.bottom-bg .ul-box ul li .li-content .li-box .box2,
.bottom-bg .ul-box ul li .li-content .li-box .box3,
.bottom-bg .ul-box ul li .li-content .li-box .box4 {
  width: 23%;
  height: 50%;
  position: absolute;
}
.bottom-bg .ul-box ul li .li-content .li-box .box1 h5,
.bottom-bg .ul-box ul li .li-content .li-box .box2 h5,
.bottom-bg .ul-box ul li .li-content .li-box .box3 h5,
.bottom-bg .ul-box ul li .li-content .li-box .box4 h5 {
  height: 50%;
  color: #fff;
  font-size: 0.7rem;
  font-weight: normal;
  display: table;
}
.bottom-bg .ul-box ul li .li-content .li-box .box1 h5 span,
.bottom-bg .ul-box ul li .li-content .li-box .box2 h5 span,
.bottom-bg .ul-box ul li .li-content .li-box .box3 h5 span,
.bottom-bg .ul-box ul li .li-content .li-box .box4 h5 span {
  display: table-cell;
  vertical-align: middle;
}
.bottom-bg .ul-box ul li .li-content .li-box .box1 .pic,
.bottom-bg .ul-box ul li .li-content .li-box .box2 .pic,
.bottom-bg .ul-box ul li .li-content .li-box .box3 .pic,
.bottom-bg .ul-box ul li .li-content .li-box .box4 .pic {
  width: 100%;
  height: 50%;
  color: #fff;
  font-size: 0.7rem;
}
.bottom-bg .ul-box ul li .li-content .li-box .box1 .pic img,
.bottom-bg .ul-box ul li .li-content .li-box .box2 .pic img,
.bottom-bg .ul-box ul li .li-content .li-box .box3 .pic img,
.bottom-bg .ul-box ul li .li-content .li-box .box4 .pic img {
  width: 1rem;
  vertical-align: bottom;
  margin-right: 5%;
}
.bottom-bg .ul-box ul li .li-content .li-box .box1 {
  left: 0;
  top: 0;
}
.bottom-bg .ul-box ul li .li-content .li-box .box2 {
  right: 0;
  top: 0;
}
.bottom-bg .ul-box ul li .li-content .li-box .box3 {
  left: 0;
  bottom: 0;
}
.bottom-bg .ul-box ul li .li-content .li-box .box4 {
  right: 0;
  bottom: 0;
}
.bottom-bg .ul-box ul li:nth-of-type(1) {
  transform: translateY(100%); 
  animation: di2 1s linear forwards 7s;
}
.bottom-bg .ul-box ul li:nth-of-type(2) {
  transform: translateY(100%);
  animation: di2 1s linear forwards 7s;
}
.bottom-bg .ul-box ul li:nth-of-type(3) {
  transform: translateY(100%);
  animation: di2 1s linear forwards 7s;
}
@keyframes show1 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.25;
  }
}
@keyframes show2 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.5;
  }
}
@keyframes show3 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.75;
  }
}
@keyframes show4 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  100% {
    opacity: 1;
  }
}
@keyframes come1 {
  0% {
    opacity: 0;
    left: 40%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}
@keyframes come2 {
  0% {
    opacity: 0;
    right: 40%;
  }
  100% {
    opacity: 1;
    right: 0;
  }
}
@keyframes come3 {
  0% {
    opacity: 0;
    top: 40%;
  }
  100% {
    opacity: 1;
    top: 15%;
  }
}
@keyframes come4 {
  0% {
    opacity: 0;
    bottom: 40%;
  }
  100% {
    opacity: 1;
    bottom: 10%;
  }
}
@keyframes rotate1 {
  0% {
    transform: translateY(-50%) rotateY(0);
  }
  100% {
    transform: translateY(-50%) rotateY(360deg);
  }
}
@keyframes inner1 {
  0% {
    left: 40%;
    opacity: 0;
  }
  100% {
    left: 10%;
    opacity: 1;
  }
}
@keyframes inner2 {
  0% {
    right: 40%;
    opacity: 0;
  }
  100% {
    right: 10%;
    opacity: 1;
  }
}
@keyframes arrow1 {
  0% {
    opacity: 0.2;
    left: 10%;
  }
  100% {
    opacity: 1;
    left: 15%;
  }
}
@keyframes arrow2 {
  0% {
    opacity: 0.2;
    right: 10%;
  }
  100% {
    opacity: 1;
    right: 15%;
  }
}
@keyframes meter {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0) rotate(0);
  }
  40% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(0.8) rotate(360deg);
  }
  80% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(0.8) rotate(540deg);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1) rotate(540deg);
  }
}
@keyframes animate {
  0% {
    opacity: 0;
  }
  100% {
    opacity: .7;
  }
}
@keyframes sale {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    -webkit-transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale3d(1, 1, 1) translate3d(0, 60px, 0);
    transform: scale3d(1, 1, 1) translate3d(0, 0, 0);
    -webkit-animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
}
@keyframes animate1 {
  0% {
    left: -50%;
  }
  100% {
    left: 50%;
  }
}
@keyframes animate2 {
  0% {
    left: 150%;
  }
  100% {
    left: 50%;
  }
}
@keyframes di2 {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
@keyframes show5 {
  0% {
    opacity: 0;
    transform: translateY(100%) scale(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes move {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.date {
        font-size: 24px;
        display: flex;
        justify-content: space-around;
        color: #fff;
        padding-left: 10px;
        position: absolute;
        right: 3%;
        top: 2%;
    }
</style>